import Quill from 'quill'
import BlotFormatter from 'quill-blot-formatter'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// Register BlotFormatter
// We check if it's already registered to avoid warnings in development with HMR, 
// though importing this module once should suffice in production.
if (!Quill.imports['modules/blotFormatter']) {
  Quill.register('modules/blotFormatter', BlotFormatter)
}

// Custom Image Blot to preserve width/height/style attributes
const BaseImage = Quill.import('formats/image')
const ATTRIBUTES = ['alt', 'height', 'width', 'style']

class Image extends BaseImage {
  static formats(domNode) {
    return ATTRIBUTES.reduce((formats, attribute) => {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute)
      }
      return formats
    }, {})
  }

  format(name, value) {
    if (ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value)
      } else {
        this.domNode.removeAttribute(name)
      }
    } else {
      super.format(name, value)
    }
  }
}
Quill.register(Image, true)

export default Quill
